import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { CertificationCreateButton } from './CreateButton'
import { CertificationsModalForm } from './Form'
import { CertificationManageProps } from './interface'
import { CertificationsList } from './List'
import { CertificationManagePovider } from './Store'

export const CertificationManage = ({
  value,
  onChange,
  disabled
}: CertificationManageProps) => {
  return (
    <div>
      <CertificationManagePovider value={value} onChange={onChange}>
        <CertificationCreateButton disabled={disabled} />
        <CertificationsList disabled={disabled} />
        <CertificationsModalForm
          mode={disabled ? FormMode.READ : FormMode.CREATE}
        />
      </CertificationManagePovider>
    </div>
  )
}
